import {LEFT_INDEX, RIGHT_INDEX} from '../range-slider.constants';

/**
 * Абстрактный класс для разных вариантов расчета Range
 */
export abstract class RangeCalc {
  protected innerLimits;
  protected outerLimits;

  public constructor(innerlimits, outerLimits) {
    this.innerLimits = innerlimits;
    this.outerLimits = outerLimits;
  }

  /**
   * Возвращает либо обе границы либо с пропусками
   */
  abstract bordersWithHoles();

  /**
   * Расчитывет смещение относительно левой границы
   * поддерживает отрицательные смещения
   * @param leftSliderValue
   * @returns {number}
   */
  abstract calcLeftBoundValue(leftSliderValue): number;

  /**
   * Расчитывет смещение относительно правой границы
   * поддерживает отрицательные смещения
   * @param rightSliderValue
   * @returns {number}
   */
  abstract calcRightBoundValue(rightSliderValue): number;

  /**
   * Мапирует смещение относительно границы на значение слайдера
   * для левого элемента слайдера
   * @param leftBoundValue
   * @returns {number}
   */
  abstract calcLeftSliderValue(leftBoundValue): number;

  /**
   * Мапирует смещение относительно границы на значение слайдера
   * для правого элемента слайдера
   * @param rightBoundValue
   * @returns {number}
   */
  abstract calcRightSliderValue(rightBoundValue): number;

  /**
   * Проверяет, что расчитанные границы не выходят за пределы слайдера
   * @param _newValue
   * @returns {any}
   */
  protected limitByOuterLimits(_newValue): number {
    if (_newValue > this.outerLimits[RIGHT_INDEX]) {
      return this.outerLimits[RIGHT_INDEX];
    }
    if (_newValue < this.outerLimits[LEFT_INDEX]) {
      return this.outerLimits[LEFT_INDEX];
    }
    return _newValue;

  }
}

/**
 * Расчет значений для случая "только левая граница"
 */
class LeftBoundRange extends RangeCalc {
  public bordersWithHoles() {
    return [this.innerLimits[LEFT_INDEX], undefined];
  }

  public calcLeftBoundValue(leftSliderValue): number {
    return leftSliderValue - this.innerLimits[LEFT_INDEX];
  }

  public calcRightBoundValue(rightSliderValue): number {
    return rightSliderValue - this.innerLimits[LEFT_INDEX];
  }


  public calcLeftSliderValue(leftBoundValue): number {
    return this.limitByOuterLimits(this.innerLimits[LEFT_INDEX] + leftBoundValue);
  }

  public calcRightSliderValue(rightBoundValue): number {
    return this.limitByOuterLimits(this.innerLimits[LEFT_INDEX] + rightBoundValue);
  }
}

/**
 * Расчет значений для случая "только правая граница"
 */
class RightBoundRange extends RangeCalc {
  public bordersWithHoles() {
    return [undefined, this.innerLimits[RIGHT_INDEX]];
  }

  public calcLeftBoundValue(leftSliderValue): number {
    return leftSliderValue - this.innerLimits[RIGHT_INDEX];
  }

  public calcRightBoundValue(rightSliderValue): number {
    return rightSliderValue - this.innerLimits[RIGHT_INDEX];
  }


  public calcLeftSliderValue(leftBoundValue): number {
    return this.limitByOuterLimits(this.innerLimits[RIGHT_INDEX] + leftBoundValue);
  }

  public calcRightSliderValue(rightBoundValue): number {
    return this.limitByOuterLimits(this.innerLimits[RIGHT_INDEX] + rightBoundValue);
  }


}

/**
 * Расчет значений для случая "левая и правая граница"
 */
class BothBoundRange extends RangeCalc {
  public bordersWithHoles() {
    return [this.innerLimits[LEFT_INDEX], this.innerLimits[RIGHT_INDEX]];
  }

  public calcLeftBoundValue(leftSliderValue): number {
    return leftSliderValue - this.innerLimits[LEFT_INDEX];
  }

  public calcRightBoundValue(rightSliderValue): number {
    return rightSliderValue - this.innerLimits[RIGHT_INDEX];
  }

  public calcLeftSliderValue(leftBoundValue): number {
    return this.limitByOuterLimits(this.innerLimits[LEFT_INDEX] + leftBoundValue);
  }

  public calcRightSliderValue(rightBoundValue): number {
    return this.limitByOuterLimits(this.innerLimits[RIGHT_INDEX] + rightBoundValue);
  }
}

const FACTORY = {
  LEFT_BORDER: (innerLimits, outerLimits) => new LeftBoundRange(innerLimits, outerLimits),
  RIGHT_BORDER: (innerLimits, outerLimits) => new RightBoundRange(innerLimits, outerLimits),
  BOTH_BORDERS: (innerLimits, outerLimits) => new BothBoundRange(innerLimits, outerLimits)
};

export function planingAreaRangeCalcFactory(rangeType: string, innerLimits, outerLimits) {
  return FACTORY[rangeType](innerLimits, outerLimits);
}
